import React from 'react'
import clx from "classnames"
import {  teamUserGroups } from "../../../dummy/users"


export const MembersDetail = ({mobile}) => {

    return (
        <React.Fragment>
              <div className={clx(
                !mobile ? 'hidden lg:block':'block',
                'detail lg:col-span-2 bg-gray-100 dark:bg-zinc-900 p-3 overflow-y-auto h-screen'
              )}>

                {teamUserGroups.map((group,i)=>(
                    <div>
                    {group.name && (
                        <div className="flex justify-between items-center">
                            <h3 className="text-gray-500 font-medium mx-0">{group.name}</h3>
                        {group.size && ( <h3 className="text-blue-400">({group.size})</h3> )}
                        </div>
                    )}
                    <ul>
                        {group.list?.map((user,i)=>(
                        <li
                            className="hover:bg-gray-200 dark:hover:bg-gray-800 cursor-pointer "
                        >
                            <div className="flex gap-3 p-2 items-center">
                            <div className="relative">
                                {user.avatar && <img src={user.avatar} className="h-10" /> }
                                {!user.avatar && <React.Fragment>
                                <div 
                                    style={{background:user.color}}
                                    className="h-10 w-10 rounded-full text-2xl flex items-center justify-center pb-1 text-white">
                                    {user.letter}
                                </div>
                                </React.Fragment> }
                                {user.type && (
                                <div
                                className={clx(
                                    {'bg-green-500':user.type=='online'},
                                    {'bg-red-500':user.type=='offline'},
                                    {'bg-yellow-500':user.type=='busy'},
                                    {'bg-gray-500':user.type=='afk'},
                                    `absolute right-0 bottom-0 rounded-full h-3 w-3 border border-white border-2`
                                )}
                                ></div>
                                )}
                            </div>
                            <div className="">
                                <div className="flex">
                                <p style={{color:user.foreground}} >{user.name}</p>
                                {user.bot && (
                                    <div
                                    className="m-1 px-2 ml-2 text-xs bg-blue-500 text-white flex items-center justify-center rounded-full"
                                    >
                                    BOT
                                    </div>
                                )}
                                </div>
                                <div className="text-gray-500 text-sm">{user.description}</div>
                            </div>
                            </div>
                            </li>
                        ))}
                        </ul>
                    </div>
                ))}
                
            </div>
        </React.Fragment>
    )
}